import _ from "lodash";
import { injectReducer } from "store/reducers";
import {
  CircularRoutes,
  SchoolSetup,
  Trash,
  IntegrationSettings,
  Transcripts,
  SchoolAnalytics,
  StaffPermissions,
  AcademicYearTransition,
  QuestionBank,
  AcademyAnalytics,
  SchoolSettings,
  BulkUploadActions,
  AttendanceSettingsV2,
  AttendanceAndTimetableSettings,
  NotificationsManager,
  RolesAndPermissions,
  ActivityLogs,
} from "./routes";
import BehaviourManagement from "BehaviourManagement";
import BehaviourConfiguration from "BehaviourConfiguration";
import Incident from "Incident";
import NotAuthorized from "AppComponents/NotAuthorized";
import CurriculumProgram from "./routes/CurriculumProgram";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AssessmentDetails } from "Assessments";
import MessagingV2 from "Platform/routes/MessagingV2";
import ProductUpdates from "Teacher/routes/ProductUpdates";
import { getRelativePath } from "Utils";
import ProductUpdatesV2 from "Teacher/routes/ProductUpdatesV2";

const mergeObjectsWithFunctionStacking = (routeConfig, options) => {
  const mergeCustomizer = (objValue, srcValue) => {
    if (_.isFunction(objValue) && _.isFunction(srcValue)) {
      return (...params) => {
        objValue(...params);
        srcValue(...params);
      };
    }
  };
  return _.mergeWith(routeConfig, options, mergeCustomizer);
};
const omittedPathForStaffPermissionEnhancer = ["not-authorized"];
export default store => ({
  path: "administrator",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "administrator" */ "./containers/AdministratorContainer"
        ),
        import(
          /* webpackChunkName: "administrator" */ "./modules/AdministratorModule"
        ),
        import(
          /* webpackChunkName: "administrator" */ "Worksheet/modules/WorksheetModules"
        ),
        import(
          /* webpackChunkName: "administrator" */ "./modules/CommonModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const worksheetModule = importedModule2;
          const commonReducerForAdmin = importedModule3;
          injectReducer(store, {
            key: "administrator",
            reducer,
          });
          injectReducer(store, {
            key: worksheetModule.NAME,
            reducer: worksheetModule.default,
          });
          const commonAdminReducer = commonReducerForAdmin.default;
          const commonAdminKey = commonReducerForAdmin.NAME;
          injectReducer(store, {
            key: commonAdminKey,
            reducer: commonAdminReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter: (nextState, replace) => {
    const pathname = _.get(nextState, "location.pathname", "");
    const parts = _.split(pathname, "/");
    if (parts.includes("school-analytics")) {
      replace(getRelativePath("../custom-reports"));
    }
  },

  childRoutes: _.map(
    [
      AcademicYearTransition(store),
      Transcripts(store),
      ..._.map(CircularRoutes, comp => comp(store)),
      ..._.map(MessagingV2, comp => comp(store)),
      SchoolSetup(store),
      SchoolAnalytics(store),
      ActivityLogs(store),
      Trash(store),
      IntegrationSettings(store),
      AssessmentDetails(store),
      // AssessmentDetails is being used in SnP, hence not to be removed.
      StaffPermissions(store),
      NotAuthorized(),
      StaffPermissions(store),
      RolesAndPermissions(store),
      QuestionBank(store),
      AcademyAnalytics(store),
      SchoolSettings(store),
      BulkUploadActions(store),
      AttendanceSettingsV2(store),
      AttendanceAndTimetableSettings(store),
      ProductUpdates(store),
      BehaviourConfiguration(store),
      BehaviourManagement(store),
      Incident(store),
      NotificationsManager(store),
      ProductUpdatesV2(store),
      CurriculumProgram(store), // this needs to be ad bottom otherwise routes after this will not be matched
    ],
    routeConfig => {
      const { path } = routeConfig;
      if (!_.includes(omittedPathForStaffPermissionEnhancer, path)) {
        return mergeObjectsWithFunctionStacking(routeConfig);
      } else return routeConfig;
    }
  ),
});
